var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle4E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.9,155.9c-0.7-1.7-1.5-3.3-2.4-4.8c-3.3-5.7-7.7-10.6-13.5-13.6c2.4-7.6-2.2-16.8-7.5-22.1 c-9.8-8.9-21-15.5-32.8-19.3c-2.4-0.8-4.8-1.4-7.2-1.9c-8.1-2.3-16.2-3.7-24.4-4.4c-2.7-0.2-5.5-0.4-8.2-0.5 c-18.4-0.4-37.4,1-55.8,6c-2.6,0.7-5.2,1.5-7.8,2.3c-24.4,9.2-47.8,25.1-56.8,50.4c-0.9,2.2-1.8,4.5-2.5,6.7 c-1.2,3.4-2.1,6.9-2.9,10.5c-2.9,12.3-3.2,24.5-1.6,36.6c0.3,2.4,0.7,4.8,1.2,7.2c2.9,17.3,10.3,33.2,15.1,49.7 c0-20.1,8.9-40,25.2-52.4c18.2-13.8,39-27.3,60.5-34.9c-18.7,12.2-33.7,23.8-50.6,34.5c15.2-2.1,24.9-5.4,37.2-9.9 c11.2-4.1,30.3-10.3,39.7-17.6c-14.7,12-29.2,25.4-47.8,31.4c11.5,1.7,25.6-2.7,36.5-6.4c11.7-4,20.2-7.7,31.6-12.8 c7.8-3.4,24.7-11.4,34.4-18c11,14,12,33.4,13.9,50.2c0.1,2.1,0.3,4.1,0.5,6.2c0.3,4.1,0.8,8.2,1.4,12.2c0.2,1.7,0.5,3.4,0.7,5.2 c0.8,6.1,1.8,12.6,3.8,18.7c1.6-10.1,5.3-19.2,9.9-28c0.8-1.5,1.6-3.1,2.5-4.6c4.4-6.1,7.3-12.6,9.2-19.4 c0.5-1.7,0.9-3.4,1.2-5.1C478.2,190.9,481.3,171.7,472.9,155.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3D3433",
    d: "M349.5,105.8c-33.5,3.4-61.2,23.2-79.2,52c-17.7,30.4-15.1,64.8-4.3,94.1c0.4-4.3,1.3-8.6,2.5-12.7 C252.8,174.5,293.1,120.9,349.5,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3433",
    d: "M316.7,175.1c3.9-2.2,10.3-5.5,14.5-7.4c28-13.7,63.8-20.6,77.8-47c-25.5,18.1-56.4,21.3-83.6,34.7 c-4.7,2.3-9.2,4.7-13.6,7.4c-25.2,15.4-44.2,37.7-40.5,68.6c2.6-5.8,5.9-11.2,10.1-16C287.3,196.9,300.3,184.4,316.7,175.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3433",
    d: "M441.1,144.1c-25.7,22.8-55.7,38.4-86.1,52.5c-7.7,5.5-16,10.4-25.2,13.3c11.5,1.7,25.6-2.7,36.5-6.4 c11.7-4,20.2-7.7,31.6-12.8c3.1-1.4,7.6-3.4,12.5-5.8C423.1,173.4,433.6,159.6,441.1,144.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle4E);
export default __webpack_public_path__ + "static/media/man_hairstyle_4e.81e18971ed6d994a0d4ccdbda1e66c2e.svg";
export { ForwardRef as ReactComponent };